import { create } from 'zustand';
import { useNotificationStore } from '../notificationStore';
import { ApiUtils } from '@shared/utils';
import { MiscApi, type StoreBaseReturn, type ApprovePasswordRequest } from '@shared/api';
import { Constants } from '@shared/widgets';

interface UseApprovePasswordStore {
  loading: boolean;
  data: boolean | null;
  error: string | null;
  approvePassword: (request: ApprovePasswordRequest, signal?: AbortSignal) => Promise<StoreBaseReturn<boolean | null>>;
  clear: () => void;
}

export const useApprovePasswordStore = create<UseApprovePasswordStore>((set) => ({
  loading: false,
  data: null,
  error: null,

  approvePassword: async (request, signal) => {
    try {
      set({ loading: true, data: null, error: null });
      await MiscApi.approvePassword(request, signal);
      set({ loading: false, data: true });
      return { loading: false, data: true };
    } catch (error) {
      set({ error: ApiUtils.getApiError(error), loading: false, data: false });
      useNotificationStore.getState().setError(Constants.PASSWORD_ERROR_MESSAGE);
      return { loading: false, data: false, error: ApiUtils.getApiError(error) };
    }
  },

  clear: () => set({ loading: false, data: null, error: null }),
}));
